module.exports = __webpack_public_path__ + "static/media/lightredphoto.9bebd229.jpg";